export class PostingMethodDto {
  postingType: string;
  debit: boolean;
  credit: boolean;
  duplicate: string;
  houseSide: boolean;
  duplicateExternal: string;
}
